import React from 'react';
import './Navigation.css';

function Navigation({ activeView, setActiveView, onLogout, userInfo, selectedDevice, groupDevices, onSwitchDevice, onChangeGroup, role }) {
  const hasMultipleDevices = groupDevices && groupDevices.length > 1;

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="brand-icon">
          <img src="/logo192.png" alt="PowerView" style={{ width: 28, height: 28, borderRadius: 6 }} />
        </div>
        <div className="brand-text">
          <span className="brand-name">PowerView</span>
          <span className="brand-sub">Energy Management System</span>
        </div>
      </div>

      <div className="sidebar-status">
        <div className="status-dot"></div>
        <span>System Online</span>
      </div>

      {/* Device switcher section */}
      {selectedDevice && (
        <div className="sidebar-device">
          <div className="nav-section-label">Asset</div>
          {hasMultipleDevices ? (
            <select
              className="device-select"
              value={selectedDevice.deviceId}
              onChange={(e) => onSwitchDevice && onSwitchDevice(e.target.value)}
            >
              {groupDevices.map((d) => (
                <option key={d.deviceId} value={d.deviceId}>
                  {d.vehicleId || d.deviceId}
                </option>
              ))}
            </select>
          ) : (
            <div className="device-name">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="6" width="22" height="12" rx="2" ry="2" />
                <line x1="23" y1="13" x2="23" y2="11" />
              </svg>
              <span>{selectedDevice.vehicleId || selectedDevice.deviceId}</span>
            </div>
          )}
          {onChangeGroup && (
            <button className="change-group-link" onClick={onChangeGroup}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Change Group
            </button>
          )}
        </div>
      )}

      <nav className="sidebar-nav">
        <div className="nav-section-label">Overview</div>
        <button
          className={activeView === 'dashboard' ? 'sidebar-nav-button active' : 'sidebar-nav-button'}
          onClick={() => setActiveView('dashboard')}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="9" />
            <rect x="14" y="3" width="7" height="5" />
            <rect x="14" y="12" width="7" height="9" />
            <rect x="3" y="16" width="7" height="5" />
          </svg>
          <span>Dashboard</span>
        </button>

        <div className="nav-section-label">Monitoring</div>
        <button
          className={activeView === 'live' ? 'sidebar-nav-button active' : 'sidebar-nav-button'}
          onClick={() => setActiveView('live')}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
          <span>Live Status</span>
        </button>

        <div className="nav-section-label">Analytics</div>
        <button
          className={activeView === 'rbms' ? 'sidebar-nav-button active' : 'sidebar-nav-button'}
          onClick={() => setActiveView('rbms')}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="20" x2="18" y2="10" />
            <line x1="12" y1="20" x2="12" y2="4" />
            <line x1="6" y1="20" x2="6" y2="14" />
          </svg>
          <span>RBMS History</span>
        </button>
        <button
          className={activeView === 'module' ? 'sidebar-nav-button active' : 'sidebar-nav-button'}
          onClick={() => setActiveView('module')}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="3" y="14" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
          </svg>
          <span>
            {/^DALYLV$/i.test(selectedDevice?.carProfile?.model || '')
              ? 'Cell History'
              : 'Module History'}
          </span>
        </button>


        <button
          className={activeView === 'energy' ? 'sidebar-nav-button active' : 'sidebar-nav-button'}
          onClick={() => setActiveView('energy')}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>
          <span>Daily Usage</span>
        </button>

        <button
          className={activeView === 'widgets' ? 'sidebar-nav-button active' : 'sidebar-nav-button'}
          onClick={() => setActiveView('widgets')}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="9" />
            <rect x="14" y="3" width="7" height="5" />
            <rect x="14" y="12" width="7" height="9" />
            <rect x="3" y="16" width="7" height="5" />
          </svg>
          <span>Custom Widgets</span>
        </button>
      </nav>

      <div className="sidebar-footer">
        {userInfo && (
          <div className="sidebar-user">
            <div className="user-avatar">
              {userInfo.firstName?.charAt(0) || 'U'}
            </div>
            <div className="user-details">
              <span className="sidebar-user-name">{userInfo.firstName} {userInfo.lastName}</span>
              <span className="sidebar-user-role">{userInfo.username}</span>
            </div>
          </div>
        )}
        <button className="sidebar-logout" onClick={onLogout}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}

export default Navigation;

